(() => {
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const running = new Set();
  const animate = (element, frames, options) => {
    if (preference.matches || !element.animate) return;
    const animation = element.animate(frames, options);
    running.add(animation);
    animation.finished.then(() => running.delete(animation)).catch(() => running.delete(animation));
  };
  preference.addEventListener('change', event => {
    if (event.matches) { running.forEach(animation => animation.cancel()); running.clear(); }
  });
  if (!customElements.get('nidol-proof-gallery')) {
    customElements.define('nidol-proof-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.addEventListener('click', event => {
          const choice = event.target.closest('[data-proof-choice]');
          if (!choice || !this.contains(choice)) return;
          const image = this.querySelector('.nd-proof__stage img');
          const caption = this.querySelector('[data-proof-caption]');
          if (!image || !caption) return;
          image.getAnimations().forEach(animation => animation.cancel());
          image.removeAttribute('srcset');
          image.src = choice.dataset.proofSrc;
          image.alt = choice.querySelector('img')?.alt || choice.dataset.proofLabel;
          caption.textContent = choice.dataset.proofLabel;
          this.querySelectorAll('[data-proof-choice]').forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
          animate(image, [{ opacity: .45, transform: 'scale(.985)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 360, easing: 'cubic-bezier(.2,.65,.3,1)' });
        });
      }
    });
  }
  const initialize = root => {
    if (preference.matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const element = entry.target;
        observer.unobserve(element);
        animate(element, [{ opacity: .2, transform: 'translateY(14px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 560, delay: Number(element.dataset.ndRevealDelay || 0), easing: 'cubic-bezier(.2,.65,.3,1)' });
      });
    }, { threshold: .12 });
    root.querySelectorAll('.nd-home-shop__head,.nd-home-shop__grid .nd-pcard,.nd-home-shop__gift-grid article,.nd-home-shop__help,.nd-proof').forEach((element, index) => {
      if (element.dataset.ndMotionReady) return;
      element.dataset.ndMotionReady = 'true';
      element.dataset.ndRevealDelay = String(Math.min(index % 3 * 65, 130));
      observer.observe(element);
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
